import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography } from '../../../styles/typography';

export const cardCss = css({
  alignItems: 'center',
  backgroundColor: colorsPalette.brown10,
  borderRadius: '0 0 0 30px',
  color: colorsPalette.grey,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  margin: 16,
  height: 208,
  paddingTop: 45,
  position: 'relative',
  textDecoration: 'none',
  width: 327,
  [MediaQueries.mdAndUp]: {
    margin: '16px 32px 16px 0',
    width: 295,
  },
});

export const fileCss = css({
  fontSize: 0,
  height: '100%',
  left: 0,
  pointerEvents: 'all',
  position: 'absolute',
  top: 0,
  width: '100%',
});

export const titleCss = css(typography.effra18, {
  padding: '0 50px',
  textAlign: 'center',
  lineHeight: '22px',
  maxWidth: 360,
});

export const iconCss = css({
  color: colorsPalette.red,
  fontSize: 32,
});

export const dateCss = css(typography.effra12, {
  paddingBottom: 12,
  paddingTop: 19,
});
